import { gql } from '@apollo/client'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Table, Alert } from 'reactstrap'
import { PROCESS_LEDES_FILE_QUERY } from '../../../graphql'
import { FileUploadForm } from '../FileUploadForm'
//import '../Custom.css'
import { handleGraphQLErrors, makeInteger } from '../../../utils'

export const PROCESS_LEDES_FILE = gql(PROCESS_LEDES_FILE_QUERY)

export default function UploadLedesFile() {
  console.log('UploadLedesFile rendered')

  const navigate = useNavigate()
  const [ledesInfo, setLedesInfo] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function processFile(fileName) {
    console.log('UploadLedesFile.processFile')
    try {
      const { data, errors } = await window.apolloClient.query({ query: PROCESS_LEDES_FILE, variables: { fileName: fileName } })
      console.log(data)
      if (data.processLedesFile) {
        setLedesInfo(data.processLedesFile)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (ledesInfo) {
    if (ledesInfo.ledesErrors.length > 0) {
      let resultTables = []
      for (let i = 0; i < ledesInfo.ledesErrors.length; i++) {
        const row = []
        const resultRows = []
        const fileContents = ledesInfo.ledesErrors[i].fileContents.split('|')
        resultRows.push(<th key={ledesInfo.ledesErrors[i].lineNumber} colSpan={fileContents.length} style={{textAlign: 'center', fontWeight: 'normal', backgroundColor: '#F8D7DA'}}><b>Line Number {ledesInfo.ledesErrors[i].lineNumber}, column {ledesInfo.ledesErrors[i].columnNumber}: </b>{ledesInfo.ledesErrors[i].errorMessage}</th>)
        console.log(fileContents)
        if (fileContents.length !== 1 && fileContents[0]) {
          for (let j = 0; j < fileContents.length; j++) {
            if (makeInteger(ledesInfo.ledesErrors[i].columnNumber) === j+1) {
              row.push(<td key={j} style={{color: 'red'}}>{fileContents[j]}</td>)
            } else {
              row.push(<td key={j}>{fileContents[j]}</td>)
            }
          }
        }
        resultRows.push(<tr key={i}>{row}</tr>)
        resultTables.push(<Table bordered style={{ width: 'auto', margin: '10px auto' }}><tbody>{resultRows}</tbody></Table>)
      }
      return (
        <div className="custom-scroll timekeeper-table" >
          <form className="form">
            <div>
              {resultTables}
            </div>
            <h5 style={{ textAlign: 'center'}}>Please check your file and re-submit.</h5>
            <div className="custom-button-container">
              <Button color="primary" onClick={() => setLedesInfo(null)}>Ok</Button>
            </div>
          </form>
        </div>
      )
    } else {
      return (
        <div className="custom-scroll timekeeper-table" >
          <h5 style={{textAlign: 'center'}}><b>Your invoice number</b> {ledesInfo.invoiceNumber},<b> dated </b>{ledesInfo.invoiceDate}, <b>in the amount of </b>{ledesInfo.invoiceAmount}, <b>containing</b> {ledesInfo.numberOfItems} <b>line Items, was successfully loaded.</b></h5>
          <h5 style={{textAlign: 'center'}}><b>(Started: </b>{ledesInfo.startTime}, <b>Finished: </b>{ledesInfo.endTime}<b>)</b></h5>
          <div className="custom-button-container">
            <Button color="primary" onClick={() => navigate('/home')}>Ok</Button>
          </div>
        </div>
      )
    }
  }
  return <FileUploadForm setFileName={processFile} />
}
